import { render, staticRenderFns } from "./ResponsiveImage.vue?vue&type=template&id=f361a546&"
import script from "./ResponsiveImage.vue?vue&type=script&lang=js&"
export * from "./ResponsiveImage.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./ResponsiveImage.vue?vue&type=style&index=0&lang=sass&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "9eee964c"
  
)

export default component.exports